import { render, staticRenderFns } from "./TitleTwo.vue?vue&type=template&id=8c51f85a&scoped=true"
import script from "./TitleTwo.vue?vue&type=script&lang=js"
export * from "./TitleTwo.vue?vue&type=script&lang=js"
import style0 from "./TitleTwo.vue?vue&type=style&index=0&id=8c51f85a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c51f85a",
  null
  
)

export default component.exports